import React, { useEffect, useState } from 'react';
import PostForm from '@app/components/apps/Post/PostForm';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Col, Row } from 'antd';

const routes = [
  {
    path: '/posts',
    breadcrumbName: 'Posts',
  },
  {
    path: '/add-post',
    breadcrumbName: 'Add Post',
  },
];

const CreatePost = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Post');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);
    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <PostForm
          editable={true}
          pageTitle={'Create Post'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
          id={null}
        />
      </Col>
    </Row>
  );
};

export default CreatePost;
